import {
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
  DownloadOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { history, useModel } from "@umijs/max";
import type { MenuProps } from "antd";
import { Spin, Modal, message } from "antd";
import { createStyles } from "antd-style";
import React, { useState } from "react";
import { flushSync } from "react-dom";
import { outLogin } from "@/services/ant-design-pro/api";
import HeaderDropdown from "../HeaderDropdown";
import ChangePasswordModal from "../ChangePasswordModal";
import DataExportCenter from "../DataExportCenter";

export type GlobalHeaderRightProps = {
  menu?: boolean;
  children?: React.ReactNode;
};

export const AvatarName = () => {
  const { initialState } = useModel("@@initialState");
  const { currentUser } = initialState || {};
  return (
    <span className="anticon" style={{ color: "black" }}>
      {currentUser?.name}
    </span>
  );
};

const useStyles = createStyles(({ token }) => {
  return {
    action: {
      display: "flex",
      height: "48px",
      marginLeft: "auto",
      overflow: "hidden",
      alignItems: "center",
      padding: "0 8px",
      cursor: "pointer",
      borderRadius: token.borderRadius,
      "&:hover": {
        backgroundColor: token.colorBgTextHover,
      },
    },
  };
});

export const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({
  menu,
  children,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [isChangePasswordVisible, setIsChangePasswordVisible] = useState(false);
  const [isDataExportCenterVisible, setIsDataExportCenterVisible] = useState(false);

  // 将 useModel 移到组件顶层
  const { logout } = useModel('user');

  /**
   * 退出登录，并且将当前的 url 保存
   */
  const loginOut = async () => {
    // await outLogin();
    await logout();
    const { search, pathname } = window.location;
    const urlParams = new URL(window.location.href).searchParams;
    const searchParams = new URLSearchParams({
      redirect: pathname + search,
    });
    /** 此方法会跳转到 redirect 参数所在的位置 */
    const redirect = urlParams.get("redirect");
    // Note: There may be security issues, please note
    if (window.location.pathname !== "/user/login" && !redirect) {
      history.replace({
        pathname: "/user/login",
        // search: searchParams.toString(),
      });
    }
  };

  const { styles } = useStyles();

  const { initialState, setInitialState } = useModel("@@initialState");

  const onMenuClick: MenuProps["onClick"] = (event) => {
    const { key } = event;
    if (key === "logout") {
      flushSync(() => {
        setInitialState((s) => ({ ...s, currentUser: undefined }));
      });
      loginOut();
      return;
    } else if (key === 'dataExportCenter') {
      setIsDataExportCenterVisible(true);
    } else if (key === 'changePassword') {
      setIsChangePasswordVisible(true);
    }
    // history.push(`/account/${key}`);
  };

  const handleModalOk = () => {
    setIsModalVisible(false);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const handleChangePasswordCancel = () => {
    setIsChangePasswordVisible(false);
  };

  const handleChangePasswordSuccess = () => {
    // 密码修改成功后，可以选择是否自动登出
    // 这里可以根据业务需求决定是否自动登出
    message.info('密码修改成功，建议重新登录');
  };

  const handleDataExportCenterCancel = () => {
    setIsDataExportCenterVisible(false);
  };

  const loading = (
    <span className={styles.action}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const { currentUser } = initialState;

  if (!currentUser || !currentUser.name) {
    return loading;
  }

  const menuItems = [
    ...(menu
      ? [
          {
            key: "center",
            icon: <UserOutlined />,
            label: "个人中心",
          },
          {
            key: "settings",
            icon: <SettingOutlined />,
            label: "个人设置",
          },
          {
            type: "divider" as const,
          },
        ]
      : []),
    {
      key: 'dataExportCenter',
      icon: <DownloadOutlined />,
      label: '导出中心',
    },
    {
      key: 'changePassword',
      icon: <EditOutlined />,
      label: '修改密码',
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "退出登录",
    },
  ];

  return (
    <>
      <HeaderDropdown
        menu={{
          selectedKeys: [],
          onClick: onMenuClick,
          items: menuItems,
        }}
      >
        {children}
      </HeaderDropdown>

      <Modal
        title="操作提示"
        open={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        okText="确定"
        cancelText="取消"
      >
        <p>{modalContent}</p>
      </Modal>

      <ChangePasswordModal
        visible={isChangePasswordVisible}
        onCancel={handleChangePasswordCancel}
        onSuccess={handleChangePasswordSuccess}
      />

      <DataExportCenter
        visible={isDataExportCenterVisible}
        onCancel={handleDataExportCenterCancel}
      />
    </>
  );
};
